import React, {useEffect, useRef} from 'react';
import AxcCanvas from "../../components/control/AxcCanvas";
import Legend from "../../data/icons/임시범례.png";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {putRepXY, putSSDeviceXY} from "../../api/apiClient";
import RepeaterIcon from "../../data/icons/중계기/_THM_Mint.png";
import FireDetectionSensorIcon from "../../data/icons/화재/_THM_Mint.png";
import MotionSensorIcon from "../../data/icons/움직임/_THM_Mint.png";
import EmergencyBellIcon from "../../data/icons/비상벨/_THM_Mint.png";
import FacilityFloorEquipmentSettingNameSearchBox from "../searchBoxs/FacilityFloorEquipmentSettingNameSearchBox";


const MarkerImagePanel = ({
                            propFloorName = '층 이름',
                            propFloorData = {},
                            propUpdateList,
                            propMarkerList = [],
                            setMarkerList = null,
                            propIsRep = false,
                            showPopup,
                            propAuth
                          }) => {


  const img = `data:image/png;base64,${propFloorData.image_data}`;
  const refPanel = useRef()

  useEffect(() => {
    if (propFloorData.image_data !== undefined) {
      // stockContainer.current.style.backgroundImage = `url("data:image/png;base64,${propFloorData.image_data}")`
    }
  }, []);

  useEffect(() => {
    console.log('width', refPanel.current ? refPanel.current.offsetWidth : 0);
  }, [refPanel])

  const onSave = () => {
    if (propIsRep) {
      putRepXY(propMarkerList)
          .then(res => {
          })
    } else {
      putSSDeviceXY(propMarkerList)
          .then(res => {
          });
    }
  };

  const onReload = () => {
    propUpdateList();
  };

  const onClickMarker = (e) => {
    const id = e.target.id();
    setMarkerList(
        propMarkerList.map((elem) => {
          return {
            ...elem,
            status: (elem.id === id) ? 'Mint' : 'Normal',
            selected: (elem.id === id) ? true : false
          }
        })
    );

    const scroll = document.getElementById(id);
    scroll.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  };

  const refStage = useRef();

  const onDragEnd = (e, sensor_ty) => {
    console.log(e);
    refStage.current.setPointersPositions(e);
    let pp = refStage.current.getPointerPosition();
    let rpp = refStage.current.getRelativePointerPosition()

    // console.log(pp.y - refStage.current.offsetY());
    console.log(pp);
    console.log(rpp);
    showPopup(e, 0, rpp.x, rpp.y, sensor_ty);
  }

  return (
      <>
        <div className={"narrow-floor-plan-container-title text-center py-2"}
             ref={refPanel}>
          <span>{propFloorName}</span>
        </div>
        <AxcCanvas
            propImageSrc={img}
            //propWidth={refPanel.current ? refPanel.current.offsetWidth : 0}
            propWidthRef={refPanel}
            propMarkerList={propMarkerList}
            setMarkerList={setMarkerList}
            onClickMarker={onClickMarker}
            refStage={refStage}
        />
        <Row className={"justify-content-center"}>
          <Col md={7} className={""}>
            <Row className={"justify-content-center"}>
              <Col className={"border text-center"}>
                <img src={RepeaterIcon} className={'icon me-2 py-2'}
                     onDragEnd={(e) => {
                         if (propIsRep) {
                            onDragEnd(e)
                         }
                     }}
                />
                <span className={"align-middle fs-7"}>무선중계기</span>
              </Col>
              <Col className={"border text-center"}>
                <img src={FireDetectionSensorIcon} className={'icon me-2 py-2'}
                     onDragEnd={(e) => {
                         if (propIsRep === false) {
                            onDragEnd(e, '1');
                         }
                     }}
                />
                <span className={"align-middle fs-7"}>무선화재감지기</span>
              </Col>
              <Col className={"border text-center"}>
                <img src={EmergencyBellIcon} className={'icon me-2 py-2'}
                     onDragEnd={(e) => {
                         if (propIsRep === false) {
                            onDragEnd(e, '3');
                         }
                     }}
                />
                <span className={"align-middle fs-7"}>무선비상벨</span>
              </Col>
              <Col className={"border text-center"}>
                <img src={MotionSensorIcon} className={'icon me-2 py-2'}
                     onDragEnd={(e) => {
                         if (propIsRep === false) {
                            onDragEnd(e, '2');
                         }
                     }}
                />
                <span className={"align-middle fs-7"}>움직임감지기</span>
              </Col>
            </Row>
          </Col>

          {/*<img src={Legend} className={'col-md-8'} alt={Legend}/>*/}
          {propAuth === "2" ?
              <>
                <Col md={2} className={"text-center"}>
                  <Button variant={"secondary"} className={'px-5'} onClick={onReload}>복구</Button>
                </Col>
                <Col md={2} className={"text-center"}>
                  <Button variant={"success"} className={'px-5'} onClick={onSave}>좌표저장</Button>
                </Col>
              </>
              : ''}
        </Row>

      </>
  );
};


export default MarkerImagePanel;

